<template>
    <div>
        <slot :settings="settings" :set="set" :setToggle="toggle" :settingsValueIds="settingsValueIds"></slot>
    </div>
</template>

<script>
export default {
    props: {
        initial: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            settings: this.initial,
            settingsValueIds: Object.fromEntries(Object.keys(this.initial).map(key => { return [ key, undefined ]; }))
        }
    },
    methods: {
        set(key, value = undefined, valueId = undefined) {
            if(key && typeof key == 'object' && value == undefined) {
                Object.keys(key).forEach(k => {
                    this.$set(this.settings, k, key[k]);
                });
            } else {
                this.$set(this.settings, key, value);
                this.setValueId(key, valueId);
            }
        },
        toggle(key, value, valueUnset = null, valueId = undefined) {
            if(!(key in this.settings) || this.settings[key] === valueUnset || (valueId !== undefined && this.settingsValueIds[key] !== valueId)) {
                this.set(key, value, valueId);
            } else {
                this.set(key, valueUnset);
            }
        },
        setValueId(key, valueId) {
            this.settingsValueIds[key] = valueId;
        }
    }
}
</script>